/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */
import React from "react";
import { Helmet } from "react-helmet";
import { useSeo } from "../hooks/use-seo";
import { replaceQuotationMarksWithGuillemets } from "../util/format/guillemets";
function SEO(_ref) {
    var description = _ref.description, lang = _ref.lang, meta = _ref.meta, title = _ref.title, path = _ref.path, _ref$image = _ref.image, image = _ref$image === void 0 ? "" : _ref$image;
    var _useSeo = useSeo(), datoCmsSite = _useSeo.datoCmsSite, site = _useSeo.site;
    var siteURL = site.siteMetadata.siteUrl;
    var metaDescription = description || datoCmsSite.globalSeo.fallbackSeo.description;
    return /*#__PURE__*/ React.createElement(Helmet, {
        htmlAttributes: {
            lang: lang
        },
        defaultTitle: "MAKROSKOP - Das Magazin f\xFCr Wirtschaftspolitik",
        title: replaceQuotationMarksWithGuillemets(title),
        titleTemplate: "%s \u2013 MAKROSKOP",
        defer: false
    }, /*#__PURE__*/ React.createElement("meta", {
        name: "description",
        content: metaDescription
    }), /*#__PURE__*/ React.createElement("meta", {
        name: "twitter:card",
        content: "summary_large_image"
    }), /*#__PURE__*/ React.createElement("meta", {
        name: "twitter:title",
        content: (title || site.siteMetadata.title) + " \u2013 MAKROSKOP"
    }), /*#__PURE__*/ React.createElement("meta", {
        name: "twitter:description",
        content: metaDescription
    }), /*#__PURE__*/ React.createElement("meta", {
        name: "twitter:image",
        content: image || "/makroskop-icon.png"
    }), /*#__PURE__*/ React.createElement("meta", {
        property: "og:description",
        content: metaDescription
    }), /*#__PURE__*/ React.createElement("meta", {
        property: "og:title",
        content: (title || site.siteMetadata.title) + " \u2013 MAKROSKOP"
    }), /*#__PURE__*/ React.createElement("meta", {
        property: "og:url",
        content: "" + siteURL + (path || "")
    }), /*#__PURE__*/ React.createElement("meta", {
        property: "og:locale",
        content: "de_DE"
    }), /*#__PURE__*/ React.createElement("meta", {
        property: "og:image",
        content: "" + (image || siteURL + "/" + "makroskop-icon.png")
    }), /*#__PURE__*/ React.createElement("meta", {
        property: "og:type",
        content: "website"
    }), meta.map(function (metaData) {
        return metaData.name ? /*#__PURE__*/ React.createElement("meta", {
            name: metaData.name,
            content: metaData.content
        }) : /*#__PURE__*/ React.createElement("meta", {
            property: metaData.property,
            content: metaData.content
        });
    }));
}
SEO.defaultProps = {
    lang: "de",
    meta: [],
    description: "Das einzige Magazin f\xFCr Wirtschaftspolitik aus einer keynesianischen Perspektive in Deutschland."
};
export default SEO;
